import { render, staticRenderFns } from "./channelParams.vue?vue&type=template&id=3a1c7a72&"
import script from "./channelParams.vue?vue&type=script&lang=js&"
export * from "./channelParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1c7a72')) {
      api.createRecord('3a1c7a72', component.options)
    } else {
      api.reload('3a1c7a72', component.options)
    }
    module.hot.accept("./channelParams.vue?vue&type=template&id=3a1c7a72&", function () {
      api.rerender('3a1c7a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/channelParams.vue"
export default component.exports